webpackJsonp([224770256810939],{

/***/ 1274:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"OutlookSyncStatus","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"FAILED"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"SUCCESS"}],"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---enum-outlook-sync-status-0bfa56d23bc627988b46.js